import FAQItem from './FAQItem'

export default FAQItem
